import { featuresItems, contactData, aboutData, indexItems, appData } from '@/mocks/homeData';

export function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            平台特色
          </h2>
          <p className="text-[14px] text-foreground-500">为什么选择51吃瓜网？三大优势告诉你答案</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-8 bg-background-100 rounded-lg border border-background-200/70 text-center hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-[16px] font-bold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-[13px] md:text-[14px] text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
          {contactData.title}
        </h2>
        <p className="text-[14px] text-foreground-500 mb-6 leading-relaxed">{contactData.description}</p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
              <i className="ri-mail-send-line text-lg"></i>
            </div>
            <span className="text-[16px] font-semibold text-foreground-900">{contactData.email}</span>
          </div>
          <p className="text-[13px] text-foreground-500">{contactData.tips}</p>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto text-center">
        <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
          {aboutData.title}
        </h2>
        <p className="text-[14px] md:text-[15px] text-foreground-600 leading-relaxed max-w-[650px] mx-auto">
          {aboutData.content}
        </p>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            吃瓜专题
          </h2>
          <p className="text-[14px] text-foreground-500">按主题分类浏览，快速找到你感兴趣的吃瓜内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all no-underline"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-all flex-shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-[15px] font-bold text-foreground-900 group-hover:text-primary-700 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-[13px] text-foreground-500 mb-2">{item.desc}</p>
                <span className="inline-block px-2 py-0.5 text-[11px] font-medium bg-accent-100 text-accent-700 rounded">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-12">
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-3">
            {appData.title}
          </h2>
          <p className="text-[14px] text-foreground-500 leading-relaxed mb-5">{appData.description}</p>
          <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
            {appData.features.map((feat) => (
              <span
                key={feat}
                className="px-3 py-1.5 text-[12px] font-medium bg-secondary-100 text-secondary-700 rounded-full"
              >
                {feat}
              </span>
            ))}
          </div>
        </div>
        <div className="flex-shrink-0">
          <div className="w-[200px] md:w-[240px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 border-4 border-background-300">
            <div className="w-full h-full flex flex-col items-center justify-center bg-background-950 text-background-50 gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500">
                <i className="ri-fire-line text-lg"></i>
              </div>
              <span className="text-[12px] font-semibold font-heading">51吃瓜网</span>
              <span className="text-[10px] text-background-400">随时随地 · 掌上吃瓜</span>
              <span className="mt-2 px-4 py-1.5 text-[11px] bg-primary-500 rounded-full font-medium">
                立即体验
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}